/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchUpdateTilePlacementsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {BatchUpdateTilePlacementsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const batchUpdateTilePlacements = (request:BatchUpdateTilePlacementsRequest, options?: CashRequestOptions) => post<BatchUpdateTilePlacementsRequest, BatchUpdateTilePlacementsResponse>("/2.0/cash/batch-update-tile-placements", request, {...options, rejectOnError: true })